import { InputHTMLAttributes, useId } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

export function Input({ label, error, className = '', id, ...rest }: InputProps) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  return (
    <div className="flex flex-col gap-1.5">
      <label
        htmlFor={inputId}
        className="text-[11px] font-bold uppercase tracking-hs-overline text-hs-text-mute"
      >
        {label}
      </label>
      <input
        id={inputId}
        {...rest}
        className={[
          'w-full h-11 px-3 rounded-hs-md bg-hs-surface text-[15px] text-hs-text',
          'border border-hs-border placeholder:text-hs-text-mute',
          'focus:outline-none focus:border-hs-primary focus:ring-2 focus:ring-hs-primary/25',
          error ? 'border-hs-danger' : '',
          className,
        ].join(' ')}
      />
      {error && (
        <p role="alert" className="text-[12.5px] text-hs-danger-text">
          {error}
        </p>
      )}
    </div>
  );
}
